module.exports = __webpack_public_path__ + "static/media/minus.aae9f05d.svg";